export default __webpack_public_path__ + "static/media/BL.0479c2fa.svg";